import i from "./index60.js";
import c from "./index81.js";
import a from "./index82.js";
const s = /^https?:(?!\/\/)/i, f = /[\t\n\r]/g;
function p(t) {
  let o = 0;
  for (; o < t.length && t.charCodeAt(o) <= 32; )
    o++;
  return t.slice(o);
}
function m(t) {
  return p(t).replace(f, "");
}
function n(t, o) {
  if (typeof t == "string" && s.test(m(t)))
    throw new i(
      'Invalid URL: missing "//" after protocol',
      i.ERR_INVALID_URL,
      o
    );
}
function P(t, o, l, r) {
  n(o, r);
  let e = !c(o);
  return t && (e || l === !1) ? (n(t, r), a(t, o)) : o;
}
export {
  P as default
};
